// =============================================================================
// Global override: replace blocking alert() with non-blocking toast
// and suppress window.location.reload() when triggered by API errors.
// =============================================================================

const TOAST_DURATION = 4000;
let toastContainer = null;

function getOrCreateContainer() {
  if (toastContainer && document.body.contains(toastContainer)) return toastContainer;
  toastContainer = document.createElement('div');
  toastContainer.id = 'global-toast-container';
  toastContainer.style.cssText = `
    position: fixed; top: 16px; right: 16px; z-index: 99999;
    display: flex; flex-direction: column; gap: 8px;
    pointer-events: none; max-width: 420px;
  `;
  document.body.appendChild(toastContainer);
  return toastContainer;
}

function showToast(message) {
  const container = getOrCreateContainer();
  const toast = document.createElement('div');
  toast.style.cssText = `
    background: #323232; color: #fff; padding: 12px 20px;
    border-radius: 6px; font-size: 14px; font-family: Roboto, sans-serif;
    box-shadow: 0 4px 12px rgba(0,0,0,0.25); pointer-events: auto;
    opacity: 0; transform: translateX(40px);
    transition: opacity 0.25s, transform 0.25s;
    word-break: break-word; line-height: 1.4;
  `;
  toast.textContent = String(message);
  container.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(40px)';
    setTimeout(() => toast.remove(), 300);
  }, TOAST_DURATION);
}

// --- Override window.alert → non-blocking toast ---
const nativeAlert = window.alert.bind(window);

// Track alert calls so we can suppress reload() in the same tick
let alertCalledThisTick = false;

window.alert = function (msg) {
  alertCalledThisTick = true;
  Promise.resolve().then(() => { alertCalledThisTick = false; });
  console.warn('[alert suppressed]', msg);
  showToast(msg);
};

// --- Suppress window.location.reload after alert (API error pattern) ---
// window.location.reload is not configurable via defineProperty.
// Instead, monkey-patch it on the Location prototype.
const nativeReload = window.location.reload.bind(window.location);
try {
  Location.prototype.reload = function () {
    if (alertCalledThisTick) {
      console.warn('[reload suppressed] — triggered after API error alert');
      return;
    }
    return nativeReload();
  };
} catch (e) {
  // If prototype patching fails, leave reload as-is — toast still works
  console.warn('[toastOverride] Could not patch reload, alert override still active');
}

export { nativeAlert, nativeReload };
